export default __webpack_public_path__ + "static/media/abbv-consent.bee51710.svg";